import { initializeGeometryLoadedTasks, geometryLoadedPrerequisites } from "./GEOMETRY_LOADED/initializeTasks.js";
import { initializeFraglistLoadedTasks } from "./FRAGLIST_LOADED/initializeTasks.js";
import { initializeConsolidationComputedTasks } from "./CONSOLIDATION_COMPUTED/initializeTasks.js";
import { initializeOptimizedOnGpuTasksWebGL, initializeOptimizedOnGpuTasksWebGpu } from "./OPTIMIZED_ON_GPU/initializeTasks.js";
import { USE_WEBGPU, USE_GEOMETRY_OOC } from "../../../globals.js";

/** @import {OutOfCoreTileManagerStageConfiguration} from "../OutOfCoreTileManager.js" */
/**
 * The names of the stages
 * @enum {string}
 */
export const StageNames = {
  INITIAL: "Initial Stage",
  FRAGLIST_LOADED: "Fragment List Loaded",
  GEOMETRY_LOADED: "Geometry Loaded",
  CONSOLIDATION_COMPUTED: "Consolidation Computed",
  OPTIMIZED_ON_GPU: "On GPU (optimized)"
};

/**
 * The type of resource that is used when promoting to the next stage by the tasks in that stage
 * @enum {string}
 */
export const ResourceType = {
  NONE: "None",
  CPU_MEMORY: "Cpu Memory",
  GPU_MEMORY: "Gpu Memory"
};

let cachedDefaultStageConfiguration = null;
/**
 * Get the default stage configuration for the OutOfCoreTileManager
 * @returns {OutOfCoreTileManagerStageConfiguration[]}
 */
export const getDefaultStageConfiguration = () => {
  if (!cachedDefaultStageConfiguration) {
    cachedDefaultStageConfiguration = [
    {
      stage: StageNames.INITIAL,
      screenSpaceErrorScalingFactor: !USE_WEBGPU ? 1 : 10,
      resource: ResourceType.NONE, // No promotion to this stage, so no resource is needed
      taskInitializationFunctions: []
    },
    {
      stage: StageNames.FRAGLIST_LOADED,
      screenSpaceErrorScalingFactor: !USE_WEBGPU ? 1 : 10,
      inAsyncPromotionLimit: 100,
      minScreenSpaceError: 20,
      resource: ResourceType.NONE,
      taskInitializationFunctions: [
      initializeFraglistLoadedTasks]

    },
    {
      stage: StageNames.GEOMETRY_LOADED,
      screenSpaceErrorScalingFactor: !USE_WEBGPU ? 1 : 10,
      inAsyncPromotionLimit: 50000,
      resource: USE_GEOMETRY_OOC ? ResourceType.CPU_MEMORY : ResourceType.NONE,
      taskInitializationFunctions: [
      initializeGeometryLoadedTasks],

      prerequisites: geometryLoadedPrerequisites
    },
    ...(USE_WEBGPU ?
    [] :

    [{
      stage: StageNames.CONSOLIDATION_COMPUTED,
      screenSpaceErrorScalingFactor: 1,
      inAsyncPromotionLimit: 10,
      resource: ResourceType.NONE,
      taskInitializationFunctions: [
      initializeConsolidationComputedTasks]

    }]),

    {
      stage: StageNames.OPTIMIZED_ON_GPU,
      screenSpaceErrorScalingFactor: 1,
      inAsyncPromotionLimit: !USE_WEBGPU ? 10 : 50000,
      resource: ResourceType.GPU_MEMORY,
      taskInitializationFunctions: [
      USE_WEBGPU ? initializeOptimizedOnGpuTasksWebGpu : initializeOptimizedOnGpuTasksWebGL]

    }];

  }
  return cachedDefaultStageConfiguration;
};